<script>
    import { onMount } from 'svelte';
    import { getUserManager } from '../auth/auth';
    import { user } from '../auth/user';
    import { _ } from 'svelte-i18n';

    onMount(async () => {
        try {
            const userManager = getUserManager();
            const u = await userManager.signinRedirectCallback();

            user.set(u);

            const redirectUrl = u.state?.redirectUrl || '/';
            window.location.replace(redirectUrl);
        } catch (e) {
            console.error('Callback error:', e);
        }
    });
</script>

<p>{$_("pages.callback.LOGGING_IN")}</p>
